import { Trans } from '@lingui/react/macro';
import { IndicatorColor } from '@/components/Indicator';
import { DateDisplay } from '@/components/localization';
import React from 'react';
import { ResidentialUnitDeadlineData } from '@/types';
import { isDeadlineInPast } from '@/utils/date';
import theme from './ResidentialUnitDeadlineList.module.scss';
import { IconIndicator } from '@ygtechnologies/bygr-frontend-component-library';

interface ResidentialUnitDeadlineListProps {
    deadlines: ResidentialUnitDeadlineData[];
    type?: 'extended' | 'dashboard';
}

const ResidentialUnitDeadlineList: React.FC<ResidentialUnitDeadlineListProps> = ({ deadlines, type = 'extended' }) => {
    const showValueOrDash = (value: string | null | undefined) => {
        return value && value.trim() !== '' ? value : '-';
    };

    const renderDeadline = (dl: ResidentialUnitDeadlineData) => {
        if (dl.numberOfOptions === 0) return null;
        let color: IndicatorColor = 'success';
        const numberOfOptionsSent = dl.numberOfOptions - dl.numberOfUnsentOptions;
        if (dl.numberOfUnsentOptions !== 0) {
            if (isDeadlineInPast(dl.deadline)) {
                color = 'danger';
            } else {
                color = 'warning';
            }
        }

        if (type === 'dashboard') {
            return (
                <React.Fragment key={dl.deadlineId}>
                    <div className={theme.deadlineName}>
                        {/* <Indicator color={getDeadlineIndicatorColor(d)} /> */}
                        {showValueOrDash(dl.name)}
                    </div>
                    <div className={theme.unitCount}>
                        {dl.numberOfOptions === 0 ? (
                            <Trans>N/A</Trans>
                        ) : (
                            <>
                                <IconIndicator color={color} />

                                <Trans>
                                    {numberOfOptionsSent}/{dl.numberOfOptions} <small>choices sent</small>
                                </Trans>
                            </>
                        )}
                    </div>
                </React.Fragment>
            );
        }

        return (
            <React.Fragment key={dl.deadlineId}>
                <div>
                    {showValueOrDash(dl.name)} (<DateDisplay value={dl.deadline} />)
                </div>
                <div>
                    <IconIndicator color={color}>
                        <Trans>
                            {numberOfOptionsSent}/{dl.numberOfOptions} choices sent
                        </Trans>
                    </IconIndicator>
                </div>
            </React.Fragment>
        );
    };

    // Check if there are any deadlines to display
    const validDeadlines = deadlines.filter((dl) => dl.numberOfOptions > 0);

    if (deadlines.length === 0 || validDeadlines.length === 0) {
        return (
            <div className={type === 'extended' ? theme.grid : theme.deadlinesDashboard}>
                <div>-</div>
            </div>
        );
    }

    return (
        <div className={type === 'extended' ? theme.grid : theme.deadlinesDashboard}>
            {validDeadlines.map((dl) => renderDeadline(dl))}
        </div>
    );
};

export default ResidentialUnitDeadlineList;
